<template>
  <div class="goodAndBadScore ub ub-pj">
    <div class="basInfo-table model-info bg-w">
      <div class="row">
        <div class="title">
          <span>良好信息得分</span>
          <span class="total-box ft12">合计 {{ scoreInfo.GoodScore }}</span>
          <span class="overdue-score ft12 col-99" v-if="scoreInfo.GoodOverScore"
            >(其中已过公示截止日期的事项合计{{
              scoreInfo.GoodOverScore
            }}分)</span
          >
          <el-link icon="el-icon-warning-outline" type="info" disabled
            >物业服务评价加分、减分仅在信息录入时的自然年度内有效，次年度该信息加分、减分值自动归零</el-link
          >
        </div>
      </div>
      <div class="row_title">
        <el-table
          v-loading="goodLoading"
          element-loading-text="数据正在加载中，请稍候"
          ref="multipleTable"
          :data="goodList"
          tooltip-effect="dark"
          style="width: 100%"
          height="300px"
          :header-cell-style="{ background: 'rgb(241,243,255)' }"
          border
          :row-style="tableRowStyle"
          :highlight-current-row="true"
        >
          <template slot="empty">
            <span v-if="goodLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="80"
            type="index"
            v-bind:index="indexMethod"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            prop="ApplyContent"
            label="良好信息事项"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ThatDate"
            label="认定日期"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Score"
            label="计分"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ '+' + scope.row.Score }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ExpirationDate"
            label="公示截止日期"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.ExpirationDate == '9999-12-31T23:59:59'"
                >长期有效</span
              >
              <span v-else>{{
                scope.row.ExpirationDate | formatDate('yyyy-MM-dd')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="200"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <ps-detail @click="tableDoubleClickGood(scope.row)"
                >查看</ps-detail
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="basInfo-table model-info bg-w">
      <div class="row">
        <div class="title">
          <span>不良信息得分</span>
          <span class="total-box ft12">合计 {{ scoreInfo.BadScore }}</span>
          <span class="overdue-score ft12 col-99" v-if="scoreInfo.BadOverScore"
            >(其中已过公示截止日期的事项合计{{
              scoreInfo.BadOverScore
            }}分)</span
          >
          <el-link icon="el-icon-warning-outline" type="info" disabled
            >物业服务评价加分、减分仅在信息录入时的自然年度内有效，次年度该信息加分、减分值自动归零</el-link
          >
        </div>
      </div>
      <div class="row_title">
        <el-table
          v-loading="badLoading"
          element-loading-text="数据正在加载中，请稍候"
          ref="multipleTable"
          :data="badList"
          tooltip-effect="dark"
          style="width: 100%"
          height="300px"
          :header-cell-style="{ background: 'rgb(241,243,255)' }"
          border
          :row-style="tableRowStyle"
          :highlight-current-row="true"
        >
          <template slot="empty">
            <span v-if="badLoading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            label="序号"
            width="80"
            type="index"
            v-bind:index="indexMethod"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            prop="ApplyContent"
            label="不良信息事项"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ThatDate"
            label="信息录入日期"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Score"
            label="计分"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ExpirationDate"
            label="公示截止日期"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.ExpirationDate | formatDate('yyyy-MM-dd') }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="200"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <ps-detail @click="tableDoubleClickBad(scope.row)"
                >查看</ps-detail
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Page } from '@/models/page';
export default {
  name: 'goodAndBadScore',
  props: {
    goodList: Array,
    badList: Array,
    scoreInfo: Object,
  },
  data() {
    return {
      pages: new Page(),
      goodLoading: false,
      badLoading: false,
    };
  },
  created() {},
  methods: {
    indexMethod(index) {
      return index + 1 + (this.pages.currentPage - 1) * this.pages.currtNum;
    },
    tableDoubleClickGood(row) {
      this.$emit('change', row, 'good');
    },
    tableDoubleClickBad(row) {
      this.$emit('change', row, 'bad');
    },
    tableRowStyle({ row }) {
      let rowYear = new Date(row.ThatDate).getFullYear();
      let nowYear = new Date().getFullYear();
      if (rowYear < nowYear) {
        return { 'background-color': '#EBEBEB' };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goodAndBadScore {
  .model-info {
    background: #fff;
    .row {
      .title {
        .overdue-score {
          margin-left: 18px;
        }
      }
      .total-box {
        box-sizing: border-box;
        padding: 5px 15px;
        margin-left: 10px;
        background: #1890ff;
        color: #fff;
        border-radius: 5px;
      }
      .link {
        color: #1890ff;
        cursor: pointer;
      }
      .more-data {
        float: right;
      }
    }
    .row_title {
      min-height: 300px;
      overflow: scroll;
    }
  }
}
</style>
